<template>
    <div>
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" >
            <el-form-item label="用户名" prop="username">
                <el-input v-model="form.username" placeholder="请输入用户名(登录名)"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
                <el-radio v-model="form.sex" label="1">男</el-radio>
                <el-radio v-model="form.sex" label="0">女</el-radio>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="用户角色" prop="roleId">
                <el-select v-model="form.roleId"  placeholder="请选择用户角色" >
                    <el-option v-for="item in roleData"
                            :key="item.roleId"
                            :label="item.roleName"
                            :value="item.roleId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio v-model="form.status" label="1">正常</el-radio>
                <el-radio v-model="form.status" label="0">禁用</el-radio>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">{{ type == 'edit' ? "修改" : "创建"}}</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { editGender,editEnable } from "./system.config"
    import services from "./system.service";
    import { getRules } from "./system.rules";
    const rules = getRules(true);
    export default {
        props:{
            type:{
                type:String,
                default:'add'
            },
            params:Object,
            callback:Function,
        },
        data() {
            return {
                formName:"form",
                form:{
                    username:"",
                    sex:"1",
                    email:"",
                    mobile: null,
                    roleId:"",
                    roleIdList:[],
                    status:"1"
                },
                rules:rules,
                roleData:[],
                isDisabled:true,
                editEnable,
            }
        },
        created() {
            this.getRoleList();
            if(this.type == 'edit'){
                this.$modal.title = "修改用户";
                this.params.sex = this.params.sex+"";
                this.params.status = this.params.status+"";
                // console.log(this.params)
                this.form = this.params;
            }
        },
        computed:{
            menuBar(){
                return this.$store.state.siteParam.menuBar;
            }
        },
        methods: {
            getRoleList(){
                let menuBar = this.menuBar;
                // console.log(menuBar);
                services.getRoleList({ menuBar:menuBar }).then(res => {
                    res = res.filter(item => item.menuBar == menuBar);
                    this.roleData = res;
                })
            },
            submit(){
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if (valid){
                        if(this.type == 'edit'){
                            this.updateFn();
                        }else{
                            this.addFn();
                        }
                    }
                    return valid;
                })
            },
            updateFn(){
                this.form.roleIdList.push(this.form.roleId)
                services.updateUser(this.form).then(res => {
                    this.$message.success("修改成功")
                    this.close(true)
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            addFn(){
                this.form.roleIdList.push(this.form.roleId)
                services.addUser(this.form).then(res => {
                    this.$message.success("创建成功")
                    this.close(true)
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            cancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.$state.query.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    /*.el-dialog__wrapper .el-form-item {*/
        /*width: 200px;*/
        /*float: left;*/
    /*}*/
    /*.el-dialog__wrapper .el-form-item:nth-child(even) {*/
        /*margin-left: 40px;*/
    /*}*/
</style>
